import React from 'react';
import PropTypes from 'prop-types';
import LensIcon from '@material-ui/icons/Lens';
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';
import { withStyles } from '@material-ui/core/styles';

const green300 = green['300'];
const red300 = red['300'];

const styles = {
  green: {
    color: green300,
    height: 11,
    width: 11
  },
  red: {
    color: red300,
    height: 11,
    width: 11
  }
};

const StatusIconSmall = (props) => (
  <LensIcon className={props.enabled ? props.classes.green : props.classes.red}  />
);

StatusIconSmall.propTypes = {
  enabled: PropTypes.bool.isRequired
};

export default withStyles(styles)(StatusIconSmall);
